import { Redirect, Route, Switch } from "react-router-dom";

import Footer from "../components/Footer/Footer";
import PropTypes from "prop-types";
import React from "react";
import bgImage from "../assets/img/login_bg.jpg";
import pagesRoutes from "../routes/pages.jsx";
import styles from "assets/jss/material-dashboard-pro-react/layouts/authStyle.js";
import withStyles from "@material-ui/core/styles/withStyles";

class Pages extends React.Component {
  componentDidMount() {
    document.body.style.overflow = "unset";
  }
  render() {
    const { classes } = this.props;
    return (
      <div>
        <div className={classes.wrapper} ref="wrapper">
          <div
            id={`background-image`}
            className={classes.fullPage}
            style={{
              backgroundImage: "url(" + bgImage + ")"
            }}
          >
            <Switch>
              {pagesRoutes.map((prop, key) => {
                if (prop.collapse) {
                  return null;
                }
                if (prop.redirect) {
                  return (
                    <Redirect from={prop.path} to={prop.pathTo} key={key} />
                  );
                }
                return (
                  <Route
                    path={prop.path}
                    component={prop.component}
                    key={key}
                  />
                );
              })}
            </Switch>
            <Footer white />
          </div>
        </div>
      </div>
    );
  }
}

Pages.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(Pages);
